import { useMutation } from '@tanstack/react-query';
import type { Product } from '../types/product';
import type { LangStrings } from '../i18n/en';
import { generateProductPdf, generateDocumentPdf } from '../utils/generatePdf';

interface ProductPdfParams {
  product: Product;
  strings: LangStrings;
  companyName?: string;
  companyWebsite?: string;
}

export function useProductPdfDownload() {
  return useMutation({
    mutationFn: ({ product, strings, companyName, companyWebsite }: ProductPdfParams) =>
      generateProductPdf(product, strings, companyName, companyWebsite),
  });
}

interface DocumentPdfParams {
  products: Product[];
  title?: string;
  strings?: LangStrings;
  contactPerson?: string;
  companyName?: string;
  companyWebsite?: string;
}

export function useDocumentPdfDownload() {
  return useMutation({
    mutationFn: ({ products, title, strings, contactPerson, companyName, companyWebsite }: DocumentPdfParams) =>
      generateDocumentPdf(products, title, strings, contactPerson, companyName, companyWebsite),
  });
}
